module.exports = __webpack_public_path__ + "assets/xilanhua.9f7a56a5.svg";